import _ from 'lodash';

import ReactPlayer from 'react-player';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../shared';

import useResponsive from '../../../../utils/responsive';

const RoomTypeVideoTour = (props) => {
    const { selectedRoomType } = props;
    const { isMobile, isTablet } = useResponsive();
    const videoTourUrl = _.get(selectedRoomType, 'videoTourUrl');

    if (!videoTourUrl) {
        return null;
    }
    return (
        <div id="video-tour-section">
            <FadeInAnimation>
                <h3 style={{ marginTop: 100 }}>Video Tour</h3>
                <p className='room-type-video-tour-details'>
                    We&apos;ve got something for every taste, in every city.
                </p>
            </FadeInAnimation>
            <ReactPlayer
                className="react-player"
                url={videoTourUrl}
                playing={false}
                width="100%"
                // eslint-disable-next-line no-nested-ternary
                height={isMobile ? 220 : isTablet ? 510 : 410}
                controls
            />
        </div>
    );
};

export default RoomTypeVideoTour;

RoomTypeVideoTour.propTypes = {
    selectedRoomType: PropTypes.object,
};

